import { render } from "./nexttripcard.vue?vue&type=template&id=fc485136"
import script from "./nexttripcard.vue?vue&type=script&lang=js"
export * from "./nexttripcard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__